import { en } from './en.js';
import { fr } from './fr.js';
import { nl } from './nl.js';
export { en } from './en.js';
export { fr } from './fr.js';
export { nl } from './nl.js';
/**
 * The `documents` i18n namespace, as plain objects.
 *
 * Hosts register it themselves rather than fetching JSON:
 *   - apps/web: `i18n.addResourceBundle(lng, 'documents', res)` after init
 *     (and NOT in the `ns` array — the HTTP backend would 404-fetch it)
 *   - apps/api: passed straight into a module-scoped `i18next.createInstance()`
 */
export const documentsResources = {
    en,
    fr,
    nl,
};
//# sourceMappingURL=index.js.map